/* eslint-disable no-unused-vars */
// Keeping these unused variables so the pageNotFound page is shown
define('error/pageNotFound',['require','exports','module','lib/auth/auth','knockout'],function (require, exports, module) {
    /* eslint-enable */
    var auth = require('lib/auth/auth');
    var ko = require('knockout');

    var self = this;
    self.loggedInUser = ko.observable(false);

    self.activate = function () {
        self.loggedInUser(!!auth.getToken());
    };
});

